import { Group } from '@mantine/core'
import { t } from 'i18next'
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import {
  SuppliersProposalService,
  uploadExcelFile,
} from '../../../services/purchase-fuel/suppliers-proposal/suppliersProposal.service'
import swalAlert from '../../../utils/helpers/swalAlert'

import AppFileButton from '../../../component/common/AppFileButton.tsx'
import EntityDropdown from '../../../component/form/EntityDropdown.tsx'
import AppSection from '../../../component/layout/AppSection.tsx'
import AppTabMenu from '../../../component/layout/AppTabMenu.tsx'
import AppToolbar from '../../../component/layout/AppToolbar.tsx'
import SupplierPurchaseProposalForm from '../../../components/purchase-fuel/suppliers-proposal/SuppliersProposalForm'
import CenterService from '../../../services/centers/center.service'
import { ShoppingCartService } from '../../../services/purchase-fuel/shopping-cart/shoppingCart.service'
import { purchaseFuels } from '../../../utils/constants/navlinks-Menu'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions'
import './suppliersProposal.scss'
const SuppliersProposal = () => {
  const dispatch = useDispatch()

  const { formatMessage: msg, formatDate } = useIntl()
  const getLastPropsal = async () => {
    if (selectedProvince && selectedProvince !== undefined) {
      const resp = await SuppliersProposalService.getLast(selectedProvince)
      setDatatableProvinces(resp?.resp?.provinces)
      setCurrentId(resp?.resp?._id)
      return resp
    }
    setDatatableProvinces([])
    return null
  }

  const [centerProvinces, setCenterProvinces] = useState([])
  const [selectedProvince, setSelectedProvince] = useState(null)
  const [datatableProvinces, setDatatableProvinces] = useState([])
  const [currentId, setCurrentId] = useState(null)

  const upload = (file) => dispatch(uploadExcelFile(file))

  useEffect(() => {
    getCenterProvinces()
    getLastPropsal()
  }, [])

  useEffect(() => {
    setSelectedProvince(centerProvinces[0]?._id)
  }, [centerProvinces])

  useEffect(() => {
    getLastPropsal()
  }, [selectedProvince])

  const onUpload = async (e) => {
    // console.log('onUpload', e)
    const file = e.files[0]
    const formData = new FormData()
    formData.append('file', file)
    const resp = await upload(formData)
    // console.log('resp', resp)
    if (resp && resp?.status === 200) {
      swalAlert.succesWithTimer(msg({ id: 'uploadExcel.success' }))
    }
    e?.options?.clear()
  }

  const dataFacade = useHandlerBasicActions({
    getAll: getLastPropsal,
    createAction: SuppliersProposalService.create,
    editAction: (provinceId) =>
      SuppliersProposalService.updateByIdAndProvinceId(provinceId),
    removeAction: SuppliersProposalService.remove,
    rowsPerPageInitial: 100,
  })

  const getCenterProvinces = async () => {
    try {
      const respCentersProvinces = await CenterService.getProvinces()

      // if (!respCentersProvinces) {
      //     setCenterProvinces([]);
      //     return false;
      // }

      const localCenterProvinces = respCentersProvinces?.resp?.reduce(
        (acc, prov) => {
          const province = prov?.replace(/\t/g, '').trim()
          const newProvince = {
            _id: province,
            name: province,
            value: province,
            label: province,
            remark: false,
          }
          const index = acc.findIndex((item) => item._id > newProvince._id)
          if (index === -1) {
            return [...acc, newProvince]
          }
          return [...acc.slice(0, index), newProvince, ...acc.slice(index)]
        },
        [],
      )

      const respShoppingcartProvinces = await ShoppingCartService.getProvinces()
      const shoppingcartProvinces =
        respShoppingcartProvinces?.resp
          ?.map((prov) => prov?.replace(/\t/g, '').trim())
          .filter(Boolean) ?? []

      const updatedCenterProvinces = localCenterProvinces.map((prov) => ({
        ...prov,
        remark: shoppingcartProvinces.includes(prov._id),
      }))

      setCenterProvinces(updatedCenterProvinces)
      // setSelectedProvince(updatedCenterProvinces[0]._id)
      return false
    } catch (error) {
      setCenterProvinces([])
      return false
    }
  }

  const updatePriceSupplierProposal = async (data) => {
    const body = { pricesList: data[0]?.pricesList, _id: data[0]?._id }
    // await dataFacade.edit({ _id: dataFacade?.data?.resp?._id, body })
    await dataFacade.edit({ _id: currentId, body })
  }

  const updateSelectedProvinceSupplier = async (
    province,
    supplierId,
    fuelType,
  ) => {
    const body = {
      province,
      supplierId,
      [fuelType === 'GOA' ? 'supplierGOASelected' : 'supplierG95Selected']:
        supplierId,
      fuelType,
    }
    const resp = await SuppliersProposalService.updateSelectedProvinceSupplier({
      _id: currentId,
      province,
      body,
    })
    if (resp) dataFacade.reload()
  }

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  const data = (
    <Group w="100%" className="suppliers-wrapper">
      <SupplierPurchaseProposalForm
        dataProposal={datatableProvinces}
        handleSubmitPrice={updatePriceSupplierProposal}
        handleSelectedProvinceSupplier={updateSelectedProvinceSupplier}
        pagerOptions={pagerOptions}
      />
    </Group>
  )

  // Hola que tal

  return (
    <AppSection
      /* refactor this */
      header={<AppTabMenu options={purchaseFuels} breakpoint="xl" />}
      subheader={
        <AppToolbar
          leftSection={[
            <EntityDropdown
              w={260}
              entity="province"
              placeholder={t('province')}
              options={centerProvinces}
              value={selectedProvince}
              onChange={({ option }) => setSelectedProvince(option?.label)}
              onChangeInputsMode={false}
            />,
            <AppFileButton
              entity="excel"
              w={240}
              miw={240}
              name="files"
              accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              onChange={onUpload}
            />,
          ]}
        />
      }
    >
      {data}
    </AppSection>
  )
}

export default SuppliersProposal
